import { Component, Host, h, Method, Prop } from '@stencil/core';

@Component({
  tag: 'me-load-container',
  styleUrl: 'me-load-container.scss',
  shadow: false,
})
export class MeLoadContainer {

  @Prop({ mutable: true, reflect: true }) isLoading = true;

  render() {
    const classList = [
      'me-load-container',
      this.isLoading ? 'me-load-container--is-loading' : null,
    ].filter(c => !!c).join(' ');

    return (
      <Host class={classList}>
        <div class="me-load-container__spinner">
          <slot name="spinner">
            <i class="fa-solid fa-spinner fa-spin" />
          </slot>
        </div>
        <slot></slot>
      </Host>
    );
  }

  @Method()
  async disable() {
    await this.enable(false);
  }

  @Method()
  async enable(on = true) {
    this.isLoading = on;
  }

}
